// Merchandise trim options, independent of decoration Color Type.
export const OPTION_TYPES = ['band', 'rope', 'leather']
export function enabledOption (line, type) {
  return Number((line.style_info || {})[type + '_option']) === 1
}
export function optionsForColor (line, color, type) {
  if (!enabledOption(line, type)) return []
  return (line[type + 'Options'] || []).filter(option => type !== 'band' || !option.specific_color || option.specific_color.color_code === color.color_code)
}
export function optionLabel (type, option) {
  return type === 'leather' ? option.leather_color : [option[type + '_name'], option[type + '_color_name']].filter(Boolean).join(' - ')
}
export function reconcileColorOptions (line, color) {
  OPTION_TYPES.forEach(type => {
    const options = optionsForColor(line, color, type)
    const selected = color[type]
    color[type] = options.find(option => selected && selected.id != null && String(option.id) === String(selected.id)) ||
      (type === 'leather' && !selected && options.length === 1 ? options[0] : null)
  })
  ;(color.inner_colors || []).forEach(inner => reconcileColorOptions(line, inner))
  return color
}
export function merchandiseOptionIssues (line, requireCatalog = true) {
  const issues = []
  const visit = (color, parentOrdered = false) => {
    const ordered = (color.sizes || []).some(size => Number(size.quantity) > 0)
    if (ordered || parentOrdered) OPTION_TYPES.forEach(type => {
      const selected = color[type] && color[type].id != null && String(color[type].id) !== ''
      const valid = selected && (!requireCatalog || optionsForColor(line, color, type).some(option => String(option.id) === String(color[type].id)))
      if (enabledOption(line, type) && !valid) {
        issues.push('Choose ' + type + ' for ' + (color.customer_color_name || color.color_name || 'this color') + '.')
      }
    })
    ;(color.inner_colors || []).forEach(inner => visit(inner, ordered))
  }
  ;(line.colors || []).forEach(color => visit(color))
  return issues
}
export function blankAvailabilityWarning (section, size) {
  return !!(section && section.section_type === 'blank' && size && !(Number(size.available_quantity) > 0))
}
// Reconcile by catalog identities, never labels or inventory counts.
export function reconcileMerchandiseColors (line, authoritative, previous) {
  return authoritative.map(color => {
    const old = (previous || []).find(row => String(row.color_id) === String(color.color_id))
    const merge = (saved = {}) => reconcileColorOptions(line, {
      ...color, ...Object.fromEntries(['minimum_color_id', 'instructions', 'variant_label', 'customer_color_name', 'customer_color_code', ...OPTION_TYPES].filter(key => saved[key] !== undefined).map(key => [key, saved[key]])),
      sizes: (color.sizes || []).map(size => {
        const prior = (saved.sizes || []).find(row => String(row.size_id) === String(size.size_id))
        return { ...size, quantity: prior ? prior.quantity : (size.quantity || '') }
      }),
      inner_colors: []
    })
    const result = merge(old)
    result.inner_colors = (old && old.inner_colors || []).map(merge)
    return result
  })
}
